import React, { Component } from "react";
import {
  ClickAwayListener,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemText,
  Paper,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import TextField from "../Components/common/TextField";
import { getSearchableMenuItems } from "./menuConfig";

class MenuSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      query: "",
    };
    this.searchInputRef = React.createRef();
  }

  openResults = () => {
    this.setState({ open: true });
  };

  closeResults = () => {
    this.setState({ open: false });
  };

  clearQuery = (event) => {
    event?.stopPropagation?.();
    this.setState({ query: "", open: true }, () => {
      const input = document.getElementById("header-menu-search-input");
      input?.focus?.();
    });
  };

  handleQueryChange = (event) => {
    this.setState({ query: event.target.value, open: true });
  };

  handleSelect = (item) => {
    if (!item?.href) return;
    this.setState({ open: false, query: "" });
    if (this.props.navigate) {
      this.props.navigate(item.href);
    }
  };

  handleKeyDown = (event) => {
    if (event.key === "Escape") {
      this.closeResults();
    }
  };

  getFilteredItems = () => {
    const { userInfo, translate } = this.props;
    const { query } = this.state;
    const items = getSearchableMenuItems(userInfo || {}, translate);
    const q = String(query || "")
      .trim()
      .toLowerCase();

    if (!q) return items;

    return items.filter((item) => {
      const label = String(item.label || "").toLowerCase();
      const parent = String(item.parent || "").toLowerCase();
      const title = String(item.title || "").toLowerCase();
      return (
        label.includes(q) ||
        parent.includes(q) ||
        title.includes(q) ||
        String(item.href || "")
          .toLowerCase()
          .includes(q)
      );
    });
  };

  render() {
    const { translate } = this.props;
    const { open, query } = this.state;
    const filteredItems = open ? this.getFilteredItems() : [];

    return (
      <div className="header-menu-search">
        <ClickAwayListener onClickAway={this.closeResults}>
          <div className="header-menu-search-inner">
            <TextField
              id="header-menu-search-input"
              fullWidth
              size="small"
              value={query}
              onChange={this.handleQueryChange}
              onFocus={this.openResults}
              onKeyDown={this.handleKeyDown}
              placeholder={translate("searchMenu")}
              inputRef={this.searchInputRef}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
                endAdornment: query ? (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={this.clearQuery}
                      aria-label={translate("clear")}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
            />
            {open ? (
              <Paper
                elevation={3}
                className="header-menu-search-results"
              >
                <List dense disablePadding>
                  {filteredItems.length ? (
                    filteredItems.map((item) => (
                      <ListItem
                        button
                        key={`${item.href}-${item.title}`}
                        onClick={() => this.handleSelect(item)}
                      >
                        <ListItemText
                          primary={item.label}
                          secondary={item.parent || null}
                        />
                      </ListItem>
                    ))
                  ) : (
                    <ListItem>
                      <ListItemText
                        primary={
                          translate("noResultsFound") || "No results found"
                        }
                        secondary={
                          query ? undefined : translate("searchMenu")
                        }
                      />
                    </ListItem>
                  )}
                </List>
              </Paper>
            ) : null}
          </div>
        </ClickAwayListener>
      </div>
    );
  }
}

export default MenuSearch;
